import { useCallback, useEffect } from 'react';

import { useEbookSubmissionsLazyQuery } from '../core/graphql/operation-hooks';
import { PintoEbookSubmissionsFilter } from '../core/graphql/types';

const INITIAL_LIMIT = 10;

const useQueryEbookSubmissions = () => {
  const [queryEbookSubmissions, { data, loading }] = useEbookSubmissionsLazyQuery({ fetchPolicy: 'network-only' });

  const fetchEbookSubmissions = useCallback(
    (filter?: PintoEbookSubmissionsFilter) => {
      queryEbookSubmissions({
        variables: {
          filter: {
            ...filter,
            limit: filter?.limit || INITIAL_LIMIT,
          },
        },
      });
    },
    [queryEbookSubmissions],
  );

  useEffect(() => fetchEbookSubmissions(), [fetchEbookSubmissions]);

  return {
    fetchEbookSubmissions,
    ebookSubmissions: data?.ebookSubmissions,
    isLoadingEbookSubmissions: loading,
  };
};

export default useQueryEbookSubmissions;
